import * as React from 'react'
import { FormikProps } from 'formik'
import { Link } from 'react-router-dom'
import history from 'src/history'
import { IUserAuthorizationFormData } from '../../types/index'
import { Button, Checkbox, Input } from '@mobiscroll/react-latest'

const LoginForm = (props: FormikProps<IUserAuthorizationFormData>) => {
  const { values, touched, errors, handleSubmit, handleChange, isSubmitting } = props

  const handleRedirect = (path: string) => {
    history.push(path)
  }

  const inputProps = {
    inputStyle: 'box' as const,
    labelStyle: 'floating' as const,
    theme: 'ios'
  }

  return (
    <form className='auth-form mt4 w310' onSubmit={handleSubmit}>
      <div className='mb3'>
        <Input
          {...inputProps}
          cssClass='auth-form-input'
          error={!!(errors.emailOrUsername && touched.emailOrUsername)}
          errorMessage={errors.emailOrUsername}
          label='Username'
          name='emailOrUsername'
          startIcon='user4'
          value={values.emailOrUsername}
          onChange={handleChange}
        />
      </div>
      <div className='mb3'>
        <Input
          {...inputProps}
          cssClass='auth-form-input'
          error={!!(errors.password && touched.password)}
          errorMessage={errors.password}
          label='Password'
          name='password'
          passwordToggle={true}
          startIcon='lock'
          type='password'
          value={values.password}
          onChange={handleChange}
        />
      </div>
      <div className='items-center flex justify-between'>
        <Checkbox
          checked={values.rememberMe}
          cssClass='auth-form-checkbox'
          id='rememberMe'
          label='Remember Me'
          name='rememberMe'
          onChange={handleChange}
        />
        <Link className='auth-form-reset-password-link' to='/auth/password-recovery'>
          <span className='h5'>Forgot password?</span>
        </Link>
      </div>
      <Button className='auth-form-signin-btn' disabled={isSubmitting} variant='standard'>
        {'Sign in'}
      </Button>
      {/* Link for Driver and Rider without Auth */}
      <span className='block h5 text-center mt2'>Are you a Driver or Rider?</span>
      <span className='block h5 text-center'>Download App from Google Playstore by clicking the link below.</span>
      <div className='flex justify-between'>
        <Button className='auth-form-cta' variant='flat' onClick={() => handleRedirect('/driver-landing')}>
          <span>{'Driver'}</span>
        </Button>
        <Button className='auth-form-cta' variant='flat' onClick={() => handleRedirect('/rider-portal')}>
          <span>{'Rider'}</span>
        </Button>
      </div>
      {/* Link for Driver and Rider without Auth */}
    </form>
  )
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/authentication/LoginForm.tsx